import * as React from "react";

export const IconCopy = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 23" fill="currentColor" {...props}>
    <path
      d="M14.5 0.5H2.5C1.4 0.5 0.5 1.4 0.5 2.5V16.5H2.5V2.5H14.5V0.5ZM13.5 4.5L19.5 10.5V20.5C19.5 21.6 18.6 22.5 17.5 22.5H6.49C5.39 22.5 4.5 21.6 4.5 20.5L4.51 6.5C4.51 5.4 5.4 4.5 6.5 4.5H13.5ZM12.5 11.5H18L12.5 6V11.5Z"
      fill="currentColor"
    />
  </svg>
);
